import cx from 'classnames'
import s from './styles.module.css'

const TERMS_URL = 'https://www.trainwithkickoff.com/terms'
const PRIVACY_URL = 'https://www.trainwithkickoff.com/privacy'

export default function TrackingConsentDisclosure({
  className,
}: {
  className?: string
}) {
  return (
    <p className={cx(s.disclosure, className)}>
      By clicking continue, you confirm your agreement to our{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        Terms &amp; Conditions
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  )
}
